<template>
  <div class="tooltip-wrapper" :style="{'top': top, 'left': left, 'right': right, 'bottom': bottom}">
    <div :class="[hasPersonalizedStyledMinimal ? 'tooltipMin' : 'tooltip', { 'tooltip-active': showTooltip }]" :style="{'min-width': width, 'min-height': height}">
      <span class="tooltip-icon" v-if="haveIcon" :style="iconPosition === 'right' ? 'right: -17px;' : 'left: -17px;'">
        <ion-icon :name="icon"></ion-icon>
      </span>
      <!-- tooltip-header -->
      <div v-if="title" :class="[hasPersonalizedStyledMinimal ? 'tooltipMin-header' : 'tooltip-header']">
        <span :class="[hasPersonalizedStyledMinimal ? 'tooltipMin-title-tool' : 'tooltip-title-tool']">{{ title }}</span>
        <span v-if="!hasPersonalizedStyledMinimal" class="close-tool" @click="onClick">
          <ion-icon name="close-outline"></ion-icon>
        </span>
      </div>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "tooltip-default",
  props: {
    showTooltip: {
      default: false,
    },
    haveIcon: {
      default: false,
    },
    iconPosition: {
      default: ''
    },
    icon: {
      default: ''
    },
    title: {
      default: '',
    },
    top: {
      default: ''
    },
    bottom: {
      default: ''
    },
    left: {
      default: ''
    },
    right: {
      default: ''
    },
    width: {
      default: '300px',
    },
    height: {
      default: '250px',
    },
    hasPersonalizedStyledMinimal: {
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('close-tooltip')
    },
  },
}
</script>

<style lang="scss" scoped>

.tooltip-wrapper {
  position: relative;
}

.tooltip {
  position: absolute;
  background-color: #FFFFFF;
  padding: 15px 20px;
  border-radius: 10px !important;
  box-shadow: 0 2px 10px 2px rgba(53, 45, 165, 0.15);
  // min-height: 250px;
  // min-width: 300px;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  &-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -25px;
    height: 50px;
    width: 50px;
    box-shadow: 0 2px 10px 2px rgba(53, 45, 165, 0.15);
    border-radius: 50% !important;
    background: #FFFFFF;

    ion-icon {
      color: #3A424E;
      font-size: 29px;
    }
  }

  &-header {
    position: relative;
    padding-bottom: 10px;
    margin-left: 18px;
    margin-right: 20px;
    border-bottom: 1px solid rgba(58, 66, 78, 0.22);

    .title-tool {
      font-weight: 500;
      font-size: 14px;
      color: #3A424E;
      margin-left: 1px;
    }

    .close-tool {
      ion-icon {
        position: absolute;
        right: -23px;
        top: 1px;
        font-size: 18px;
        color: #FF6075;
        cursor: pointer;
      }
    }
  }
}

.tooltipMin {
  position: absolute;
  background-color: #FFFFFF;
  padding: 5px 5px;
  border-radius: 5px !important;
  box-shadow: 0 2px 10px 2px rgba(53, 45, 165, 0.15);
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

  &-header {
    position: relative;
    margin-left: 15px;
    margin-right: 15px;

    .title-tool {
      font-weight: 500;
      font-size: 10px;
      color: #3A424E;
      margin-left: 1px;
    }
  }
}


.tooltip-active {
  opacity: 1;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/tooltip/tooltip-default.vue